import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MatMenuModule } from '@angular/material/menu';

export interface ButtonOption {
  cta: string
  fn: (event: any, optionData?: any)=>void
  disabled?: boolean
}


export interface ButtonDisplay {
  cta: string
  options: ButtonOption[]
  stealthMode?: Boolean
}

@Component({
  selector: 'msh-button',
  imports: [MatIcon, MatMenuModule],
  template: `
    <button [class]="' w-full leading-4 ' + (stealthMode || (buttonDisplayMap && buttonDisplayMap.stealthMode) ? ' border ' + ( disabled ? '' : 'hover:border-orange-400') + ' !bg-back !text-copy !font-normal !normal-case ' : '') + ' !p-0 ' + overrideClass" [type]="type" [disabled]="disabled || isLoading" (click)="onClick.emit($event)" >
      @if(!isLoading){
        @if(options.length > 0 || (buttonDisplayMap && buttonDisplayMap.options && buttonDisplayMap.options.length > 0)){
          <div class="flex justify-between items-center">
            <div class="w-4"></div>
            <div class="py-2">{{buttonDisplayMap ? buttonDisplayMap.cta : cta}}</div>
            <div [matMenuTriggerFor]="menu" (click)="menuOpeningClick($event)" class=" hover:bg-copy/15 ml-2 " style="padding: 6px 8px 6px 0">
              <div class=" border-l-2 pl-2 ml-0 "><mat-icon class=" relative ">arrow_drop_down</mat-icon></div>
            </div>
          </div>
          <mat-menu #menu="matMenu">
            @if(buttonDisplayMap){
              @for(option of buttonDisplayMap.options; track option){
                <div (click)="option.fn($event, optionData)" [disabled]="option.disabled" mat-menu-item>{{option.cta}}</div>
              }
            } @else {
              @for(option of options; track option){
                <div (click)="option.fn($event, optionData)" [disabled]="option.disabled" mat-menu-item>{{option.cta}}</div>
              }
            }
          </mat-menu>
        } @else {
          <div class="py-2 px-4">
            {{buttonDisplayMap ? buttonDisplayMap.cta : cta}}
          </div>
        }
      }@else {
        <div class=" py-2 min-w-8">
          <div class="msh-loading-sm">&nbsp;</div>
        </div>
      }
    </button>
  `,
  styles: `
:host { display: flex; justify-content: center;}
button.warn {background-color: red; opacity: .75;}
button.dull{background-color: rgb(77, 107, 134); opacity: .75;}
button.warn:hover { opacity: 1;}
button.dull:hover { opacity: 1;}
button.warn:disabled, button.dull:disabled, button.warn:hover:disabled, button.dull:hover:disabled   { opacity: .5;}
`
})
export class ButtonComponent {
  @Input() overrideClass: string = '';
  @Input() isLoading = false;
  @Input() cta: String = 'submit';
  @Input() disabled: boolean = false;
  @Input() type: "submit" | "button" = "button"
  @Input() options: ButtonOption[] = [];
  @Input() optionData: any;
  @Input() stealthMode?: Boolean
  @Input() buttonDisplayMap?: ButtonDisplay
  @Output() onClick: EventEmitter<Event> = new EventEmitter<Event>();

  menuOpeningClick(ev: Event){
    ev.stopPropagation();
  }
}
